import React from 'react';
import { Separator } from '@yme/atoms/separator';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { RegularTextLevel3 } from '@yme/tokens/typography';
import { BannerBodyStyled, BannerHeaderStyled, BannerStyled, } from './';
export const ProductBanner = (props) => {
    const { separatorText, description, icon = null, children, headerTextNode } = props;
    return (React.createElement(FlexWrapper, { flexDirection: "column" },
        separatorText && React.createElement(Separator, { text: separatorText }),
        React.createElement(BannerStyled, { flexDirection: "column" },
            React.createElement(BannerHeaderStyled, { gap: "8px", flexDirection: "row", alignItems: "center" },
                icon,
                headerTextNode),
            React.createElement(BannerBodyStyled, null,
                description && React.createElement(RegularTextLevel3, null, description),
                children))));
};
